module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_3ef27b65.f2e46bc2.woff2";